import { render, staticRenderFns } from "./AdminProducts.vue?vue&type=template&id=193db4fc&scoped=true"
import script from "./AdminProducts.vue?vue&type=script&lang=js"
export * from "./AdminProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193db4fc",
  null
  
)

export default component.exports